<template>
  <div>
    <div class="ace-editor-main">
      <editor width="100%"
              height="100%"
              ref="editor"
              :content="content"
              v-model="content"
              :options="{
       enableBasicAutocompletion: true,
       enableSnippets: true,
       enableLiveAutocompletion: true,
       tabSize:2,
       fontSize:15,
       showPrintMargin:false,   //去除编辑器里的竖线
     }"
              :lang="language"
              @init="editorInit">
      </editor>
    </div>

  </div>
</template>
<script>
import Editor from "vue2-ace-editor";
export default {
  data() {
    return {
      content: "",
    };
  },
  props: ["value", "language", "isReadOnly"],
  components: {
    Editor,
  },
  watch: {
    value(newValue, oldValue) {
      // console.log("bbb");
      setTimeout(() => {
        this.content = newValue;
      }, 200);
    },
    isReadOnly(newValue) {
      let _this = this; // false为可编辑
      _this.$refs.editor.editor.setReadOnly(_this.isReadOnly);
    },
  },
  methods: {
    editorInit() {
      var ace = require("brace");
      require("brace/theme/chrome");
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/html");
      require("brace/mode/json");
      require("brace/snippets/json");
      require("brace/snippets/html");
      require("brace/mode/javascript"); //language
      require("brace/mode/less");
      require("brace/theme/chrome");
      require("brace/snippets/javascript"); //snippet
      /* require('brace/mode/javascript')    //language*/
      /* require('brace/mode/less')*/
      /*  require('brace/theme/tomorrow_night.js')*/
      /*  require('brace/snippets/javascript') */ //snippet*/
      let _this = this;
      _this.$refs.editor.editor.setShowFoldWidgets(true);
      _this.$refs.editor.editor.setReadOnly(_this.isReadOnly);
    },
  },
};
</script>
<style lang="scss" scoped>
.ace-editor-main {
  font-family: "Source Code Pro", "Monaco", "Menlo", "Ubuntu Mono", "Consolas",
    monospace;
  font-size: 12px;
  line-height: 18px;
  padding: 10px;
  // height: 100%;

  // Fix safari
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  box-shadow: rgb(0 0 0 / 5%) 0px 0px 20px;
  > div {
    border-radius: 8px;
  }
}
</style>